import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

interface FeedbackButtonsProps {
  conversationId: number;
  currentFeedback?: "up" | "down" | null;
  onFeedback: (conversationId: number, feedbackType: "up" | "down") => void;
  primaryColor: string;
}

const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
  conversationId,
  currentFeedback,
  onFeedback,
  primaryColor,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        justifyContent: "flex-end",
        mt: 1,
        marginRight: "-40px",
      }}
    >
      <Tooltip title="Helpful">
        <IconButton
          onClick={() => onFeedback(conversationId, "up")}
          size="small"
          sx={{
            "&.MuiIconButton-root": {
              "&  svg": {
                width: 18,
                height: 18,
              },
              color:
                currentFeedback === "up"
                  ? primaryColor
                  : "#999999",
              "&:hover  ": {
                backgroundColor: `${primaryColor} !important`,
                color: `#fff !important`,
                "&  svg": {
                  color: `#fff !important`,
                },
              },
            },
          }}
        >
          <ThumbUpIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Not helpful">
        <IconButton
          onClick={() => onFeedback(conversationId, "down")}
          size="small"
          sx={{
            "&.MuiIconButton-root": {
              "&  svg": {
                width: 18,
                height: 18,
              },
              "&:hover  ": {
                backgroundColor: `red !important`,
                color: `#fff !important`,
                "&  svg": {
                  color: `#fff !important`,
                },
              },
              color:
                currentFeedback === "down"
                  ? "#d32f2f"
                  : "#999999",
            },
          }}
        >
          <ThumbDownIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default FeedbackButtons;

